<template>
  <generic-modal :modal-key="'bonus_daily'"
                 @close="closeModal">
    <template slot="content">
      <div class="bonus_phase_box daily_bonus modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="closeModal">
        <h1>{{ getTranslations.home_bonus_daily_bonus }}</h1>
        <img src="static/images/daily_bonus/photo-DailyBonus.png" class="daily_img">
        <h2>{{ getTranslations.home_bonus_daily_bonus_title }}</h2>
        <bonus-daily-days v-for="indexCol in 3"
                          :key="indexCol"
                          :indexCol="indexCol">
        </bonus-daily-days>
      </div>
    </template>
  </generic-modal>
</template>

<script>
// daily_bonus_popup.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import modals from '@/common/modals';
import PointsBonus from './daily_bonus_modals/PointsBonus';
import GameBonus from './daily_bonus_modals/GameBonus';
import DailyBonusSpinningWheel from './daily_bonus_modals/DailyBonusSpinningWheel';
import BonusDailyDays from './BonusDailyDays';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'bonus-daily',
  components: { BonusDailyDays, GenericModal },
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    setTimeout(() => {
      // after 5 secs show modal
      let modal;
      switch (this.bonusDailyModal.dailyBonusType) {
      case 'GAMES':
        modal = GameBonus;
        break;
      case 'POINTS':
        modal = PointsBonus;
        break;
      case 'SPIN_WHEEL':
        modal = DailyBonusSpinningWheel;
        break;
      default:
        modal = null;
        break;
      }
      this.storeModalForHomePage(modal);
      modals.showHideModal(this);
    }, 5000);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'saveBonusDailyModal',
    ]),
    closeModal() {
      this.storeModalForHomePage(null);
      this.saveBonusDailyModal(null);
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BonusDaily.vue